import { isMatch, useMatches } from '@tanstack/react-router';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { RouterLink } from '@/common/components/router-links/RouterLink.ts';
import useMediaQuery from '@mui/material/useMediaQuery';

export const RouterBreadcrumbs = () => {
  const matches = useMatches();
  const isScreenLargerThanSmall = useMediaQuery((theme) => theme.breakpoints.up('sm'));

  const matchesWithCrumbs = matches.filter((match) => isMatch(match, 'loaderData.breadcrumb'));

  return (
    <Box
      borderBottom={1}
      borderColor="divider"
      px={{ xs: 2, sm: 3 }}
      py={1.5}
      bgcolor="background.paper"
    >
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" />}
        maxItems={isScreenLargerThanSmall ? 6 : 2}
      >
        {matchesWithCrumbs.map((match, index) => {
          const isLast = index === matchesWithCrumbs.length - 1;
          const breadcrumb = match.loaderData?.breadcrumb;

          if (match.status === 'pending') {
            return (
              <Typography key={match.routeId} variant="body2">
                <Skeleton variant="text" width={80} />
              </Typography>
            );
          }

          if (isLast) {
            return (
              <Typography variant="body2" key={match.routeId} color="textPrimary">
                {breadcrumb}
              </Typography>
            );
          }

          return (
            <RouterLink
              key={match.routeId}
              from={match.fullPath}
              underline="hover"
              color="textSecondary"
            >
              <Typography variant="body2">{breadcrumb}</Typography>
            </RouterLink>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};
